import { localisationOrientation } from './index';

export const getFormatNameAndOrientration = (format) => {
  let name, orientation;

  if (format?.name) {
    name = format.name;
    orientation = localisationOrientation[format.orientation]
      ? localisationOrientation[format.orientation].singular
      : '';
  } else {
    if (format?.editor_project_formats_default_pointer) {
      // In fase di creazione
      name = format.editor_project_formats_default_pointer.name;
      orientation = localisationOrientation[
        format.editor_project_formats_default_pointer.orientation
      ]
        ? localisationOrientation[
            format.editor_project_formats_default_pointer.orientation
          ].singular
        : '';
    } else {
      // In fase di modifica canvas (dopo refresh)
      // name = format.editor_project_formats_default_pointer.name;
    }
  }

  if (orientation) {
    name = `${name} ${orientation}`;
  }

  return { name, orientation };
};
